import {Pipe, PipeTransform} from '@angular/core';
import {UserRoles} from '../constants';
import {AppCommunicationService} from '../services/app-communication.service';

@Pipe({
    name: 'userRole'
})
export class UserRolePipe implements PipeTransform {
    static getCurrentUserRoles(): any[] {
        return AppCommunicationService.getCurrentUser().user.roles;
    }

    transform(requested_roles: string[], reverse?: boolean): any {
        const POSSIBLE_ROLES = UserRoles.All;
        const current_user_roles = UserRolePipe.getCurrentUserRoles();

        if (reverse) {
            return !current_user_roles.every((role) => requested_roles.indexOf(role) >= 0);
        }

        if (POSSIBLE_ROLES.some(roles => current_user_roles.includes(roles))) {
            return requested_roles.some(roles => current_user_roles.includes(roles));
        } else {
            return false;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/pipes/user-role.pipe.ts